import { render, staticRenderFns } from "./DetallesPago.vue?vue&type=template&id=39821b66"
import script from "./DetallesPago.vue?vue&type=script&lang=js"
export * from "./DetallesPago.vue?vue&type=script&lang=js"
import style0 from "./DetallesPago.vue?vue&type=style&index=0&id=39821b66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCol,VImg,VResponsive,VRow})
